import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import { postApi } from '../helpers/http';

export const requestWorkHistories = date => ({
  type: ActionTypes.REQUEST_WORK_HISTORY,
  date
})

export const receiveWorkHistories = (params, json) => ({
  type: ActionTypes.RECEIVE_WORK_HISTORY,
  date: params.date,
  items: json.data,
  receivedAt: Date.now()
})

const doFetchWorkHistories = params => async dispatch => {
  dispatch(requestWorkHistories(params))

  const data = {
        "process_type": "getDataHistoryList",
        "date_start": params.startDate,
        "date_end": params.endDate,
        "user_name": params.user_name,
        "section_name": params.section_name,
        "department_name": params.department_name,
        "pc_name": params.pc_name,
        "user_id": params.user_id,
        "section_id": params.section_id,
        "department_id": params.department_id,
        "mac_add": params.mac_add,
        // "offset": params.offset,
        // "limit": params.limit
  };

  try {
    const json = await postApi(data);
    dispatch(receiveWorkHistories(params, json))
  } catch (error) {
    console.error('Error:', error);
  };

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json);
  //   dispatch(receiveWorkHistories(params, json))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchWorkHistories = params => (dispatch, getState) => {
  return dispatch(doFetchWorkHistories(params))
}
